import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {useAuth} from './useAuth';

export const useRegister = ({initialState = {}}) => {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const {register} = useAuth();

  const onRegister = async () => {
    setLoading(true);
    let result = await register(formValues);
    if (result) {
      navigate('/login');
    } else {
      setLoading(false);
    }
  };
  return {
    formValues,
    setFormValues,
    onRegister,
    isProcessing: loading,
  };
};
